export default __webpack_public_path__ + "static/media/workflow.15af43fa.png";